/**
 * Normalize media URLs for social publish payloads (Facebook Graph requires public http(s) URLs).
 * Returns empty string if missing, whitespace-only, or not parseable as http(s).
 */
export function normalizePublicMediaUrl(url: unknown): string {
  if (url == null || typeof url !== "string") return "";
  const t = url.trim();
  if (!t) return "";
  try {
    const u = new URL(t);
    if (u.protocol !== "http:" && u.protocol !== "https:") return "";
    return u.href;
  } catch {
    return "";
  }
}
